import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ProductLocked = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M19 9.25H17.75V8C17.75 4.8296 15.1709 2.25 12 2.25C8.8291 2.25 6.25 4.8296 6.25 8V9.25H5C4.0352 9.25 3.25 10.0352 3.25 11V20C3.25 20.9648 4.0352 21.75 5 21.75H19C19.9648 21.75 20.75 20.9648 20.75 20V11C20.75 10.0352 19.9648 9.25 19 9.25ZM7.75 8C7.75 5.6567 9.6567 3.75 12 3.75C14.3433 3.75 16.25 5.6567 16.25 8V9.25H7.75V8ZM19.25 20C19.25 20.1377 19.1377 20.25 19 20.25H5C4.8623 20.25 4.75 20.1377 4.75 20V11C4.75 10.8623 4.8623 10.75 5 10.75H19C19.1377 10.75 19.25 10.8623 19.25 11V20Z"
        fill={color}
      />
      <path
        d="M12 12.75C11.0352 12.75 10.25 13.5352 10.25 14.5C10.25 15.1954 10.6609 15.7924 11.25 16.0745V17.5C11.25 17.9141 11.5859 18.25 12 18.25C12.4141 18.25 12.75 17.9141 12.75 17.5V16.0745C13.3391 15.7925 13.75 15.1955 13.75 14.5C13.75 13.5352 12.9648 12.75 12 12.75Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ProductLocked.displayName = 'ProductLocked';
